import { ApiServiceInstance } from '../../../common/api_service';

export const FETCH_SMILE_DESIGNS_START = 'FETCH_SMILE_DESIGNS_START';
export const FETCH_SMILE_DESIGNS_SUCCESS = 'FETCH_SMILE_DESIGNS_SUCCESS';
export const FETCH_SMILE_DESIGNS_ERROR = 'FETCH_SMILE_DESIGNS_ERROR';

export function fetchSmileDesigns(caseId) {
  return (dispatch) => {
    dispatch(fetchSmileDesignsStart());
    return ApiServiceInstance.fetchSmileDesigns(caseId)
      .then((list) => {
        dispatch(fetchSmileDesignsSuccess(caseId, list));
        return list;
      })
      .catch((err) => {
        dispatch(fetchSmileDesignsError(err));
      });
  };
}

export function fetchSmileDesignsStart() {
  return { type: FETCH_SMILE_DESIGNS_START };
}

export function fetchSmileDesignsSuccess(caseId, list) {
  return { type: FETCH_SMILE_DESIGNS_SUCCESS, caseId, list };
}

export function fetchSmileDesignsError(error) {
  return { type: FETCH_SMILE_DESIGNS_ERROR, error };
}
